import { skipToken, useQuery } from '@tanstack/react-query';

import { ContextSources } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_CONTEXT_SOURCES_GET_KEY = 'PRIVATE_CONTEXT_SOURCES_GET';

export type PrivateContextSourcesGetKey = [typeof PRIVATE_CONTEXT_SOURCES_GET_KEY, UsePrivateContextSourcesGetParams];

export const getPrivateContextSourcesGetKey = (
  params: UsePrivateContextSourcesGetParams,
): PrivateContextSourcesGetKey => {
  return [PRIVATE_CONTEXT_SOURCES_GET_KEY, params];
};

export type UsePrivateContextSourcesGetParams = Omit<
  Parameters<typeof ContextSources.get>[0],
  'workspaceId' | 'contextSourceId'
> & {
  contextSourceId: string | undefined;
  workspaceId: string | undefined;
};

export type UsePrivateContextSourcesGetOptions = {
  enabled?: boolean;
};

export const usePrivateContextSourcesGet = (
  params: UsePrivateContextSourcesGetParams,
  options?: UsePrivateContextSourcesGetOptions,
) => {
  const { contextSourceId, workspaceId } = params;

  return useQuery({
    queryKey: getPrivateContextSourcesGetKey(params),
    queryFn:
      !workspaceId || !contextSourceId
        ? skipToken
        : () => callAirApi(() => ContextSources.get({ ...params, contextSourceId, workspaceId })),
    enabled: !!workspaceId && !!contextSourceId && options?.enabled,
  });
};
